module.exports = __webpack_public_path__ + "img/google_play_1.bed5b292.png";